import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {IMyDate, IMyOptions} from 'ng-uikit-pro-standard';
import { Observable } from 'rxjs';

@Injectable()
export class DatePickerConfigService {

  constructor(private translateService: TranslateService) {}

  public getOptions(): Observable<IMyOptions> {
    return Observable.create(observer => {
      this.translateService.get(this.getKeys()).subscribe(values => {
        const options = this.getInitialOptions();
        options.dayLabels.su = values.Sun;
        options.dayLabels.mo = values.Mon;
        options.dayLabels.tu = values.Tue;
        options.dayLabels.we = values.Wed;
        options.dayLabels.th = values.Thu;
        options.dayLabels.fr = values.Fri;
        options.dayLabels.sa = values.Sat;
        options.dayLabelsFull.su = values.Sunday;
        options.dayLabelsFull.mo = values.Monday;
        options.dayLabelsFull.tu = values.Tuesday;
        options.dayLabelsFull.we = values.Wednesday;
        options.dayLabelsFull.th = values.Thursday;
        options.dayLabelsFull.fr = values.Friday;
        options.dayLabelsFull.sa = values.Saturday;
        options.monthLabels['1'] = values.Jan;
        options.monthLabels['2'] = values.Feb;
        options.monthLabels['3'] = values.Mar;
        options.monthLabels['4'] = values.Apr;
        options.monthLabels['5'] = values.May;
        options.monthLabels['6'] = values.Jun;
        options.monthLabels['7'] = values.Jul;
        options.monthLabels['8'] = values.Aug;
        options.monthLabels['9'] = values.Sep;
        options.monthLabels['10'] = values.Oct;
        options.monthLabels['11'] = values.Nov;
        options.monthLabels['12'] = values.Dec;
        options.monthLabelsFull['1'] = values.January;
        options.monthLabelsFull['2'] = values.February;
        options.monthLabelsFull['3'] = values.March;
        options.monthLabelsFull['4'] = values.April;
        options.monthLabelsFull['5'] = values.May;
        options.monthLabelsFull['6'] = values.June;
        options.monthLabelsFull['7'] = values.July;
        options.monthLabelsFull['8'] = values.August;
        options.monthLabelsFull['9'] = values.September;
        options.monthLabelsFull['10'] = values.October;
        options.monthLabelsFull['11'] = values.November;
        options.monthLabelsFull['12'] = values.December;
        observer.next(options);
        observer.complete();
      });
    });
  }

  private getKeys(): string[] {
    return [
      'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat',
      'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday',
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
      'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December',
    ];
  }

  private getInitialOptions(): IMyOptions {
    return {
      dateFormat: 'dd/mm/yyyy',
      firstDayOfWeek: 'mo',
      dayLabels: {},
      dayLabelsFull: {},
      monthLabels: {},
      monthLabelsFull: {},
      disableUntil: {} as IMyDate,
      disableSince: {} as IMyDate,
      disableDays: [],
      disableDateRanges: [],
      disableWeekends: false,
      enableDays: [],
      minYear: 1900,
      maxYear: 2100,
      showTodayBtn: false,
      showClearDateBtn: false,
      markCurrentDay: true,
      markDates: [],
      markWeekends: undefined,
      disableHeaderButtons: true,
      showWeekNumbers: false,
      height: '20px',
      width: '100%',
      selectionTxtFontSize: '15px',
      inline: true,
    };
  }
}
